<!-- nb-layout: the Board's toasts (success / error) need it on this chrome-less page. -->
<nb-layout>
  <nb-layout-column class="cp-column">
    <div class="cp-wrap">
      <div class="cp-sparkles" aria-hidden="true"></div>

      <div class="cp-card" [class.cp-card--done]="done">
        <!-- Cake: the candle lights once a valid date is picked. -->
        <div class="cp-cake" [class.cp-cake--lit]="isValid || done" aria-hidden="true">
          <svg viewBox="0 0 120 120">
            <g class="cp-flame">
              <ellipse cx="60" cy="22" rx="7" ry="11" fill="#f5c542" />
              <ellipse cx="60" cy="25" rx="3.5" ry="6" fill="#fff4cf" />
            </g>
            <rect x="57" y="31" width="6" height="22" rx="2" fill="#ffffff" stroke="#13234b" stroke-width="2" />
            <path d="M57 37l6-3M57 43l6-3M57 49l6-3" stroke="#c9a227" stroke-width="2" />
            <rect x="22" y="53" width="76" height="22" rx="6" fill="#ffffff" stroke="#13234b" stroke-width="2.5" />
            <path d="M22 62c6 6 12 6 19 0s13-6 19 0 13 6 19 0 13-6 19 0" fill="none" stroke="#c9a227" stroke-width="2.5" />
            <rect x="14" y="75" width="92" height="28" rx="7" fill="#13234b" />
            <circle cx="34" cy="89" r="3" fill="#c9a227" />
            <circle cx="60" cy="89" r="3" fill="#c9a227" />
            <circle cx="86" cy="89" r="3" fill="#c9a227" />
            <rect x="6" y="103" width="108" height="6" rx="3" fill="#c9a227" />
          </svg>
        </div>

        <ng-container *ngIf="loading">
          <h1 class="cp-title">One moment…</h1>
        </ng-container>

        <ng-container *ngIf="!loading && !done">
          <h1 class="cp-title">Hi {{ firstName || 'there' }}, when’s your birthday?</h1>
          <p class="cp-sub">We’d like to celebrate it with you. You only need to enter it once.</p>

          <form class="cp-form" (ngSubmit)="save()">
            <label for="dob" class="cp-label">Date of birth</label>
            <input id="dob" name="dob" type="date" class="cp-input" [(ngModel)]="dateOfBirth"
                   (ngModelChange)="error = ''" [min]="minDate" [max]="maxDate" required />

            <p class="cp-preview" *ngIf="isValid" aria-live="polite">
              Your birthday: <strong>{{ prettyDate }}</strong>
            </p>
            <p class="cp-error" *ngIf="error" role="alert">{{ error }}</p>

            <button type="submit" class="cp-btn cp-btn-primary" [disabled]="saving || !isValid">
              {{ saving ? 'Saving…' : 'Save my birthday' }}
            </button>
            <p class="cp-hint">After saving, only a Super Admin or Admin can change it.</p>
            <button type="button" class="cp-link" (click)="logout()">Log out</button>
          </form>
        </ng-container>

        <ng-container *ngIf="done">
          <h1 class="cp-title">See you on {{ prettyDate }}!</h1>
          <p class="cp-sub">Saved. Taking you to the Board…</p>
        </ng-container>

        <!-- Gold confetti on save. -->
        <div class="cp-confetti" *ngIf="done" aria-hidden="true">
          <i *ngFor="let p of confetti" [style.left.%]="p.left" [style.animation-delay.ms]="p.delay"
             [style.background]="p.color" [style.transform]="'rotate(' + p.rotate + 'deg)'"></i>
        </div>
      </div>
    </div>
  </nb-layout-column>
</nb-layout>
